import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

export const ButtonBox = styled.div`
  position: fixed;
  bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 100;
`;
export const Button = styled.button`
  padding: 19px 60px;
  gap: 10px;
  border-radius: 100px;
  font-weight: bold;
  font-size: 20px;
  border: 1px solid var(--brand-400-filled-border, #7750e9);
  background: linear-gradient(
    90deg,
    rgba(80, 39, 205, 0.8) 0%,
    rgba(145, 112, 242, 0.8) 100%
  );
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(5px);
`;
